var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyLinkIcon = function SvgCopyLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#354F5B",
    d: "M20 10.013 11.688.88v5.448H9.921c-5.48 0-9.921 4.45-9.921 9.94v2.888l.785-.862a14.07 14.07 0 0 1 10.403-4.599h.5v5.448z"
  })));
};
export { SvgCopyLinkIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwIDEwLjAxMjVMMTEuNjg4NCAwLjg4MDYxNVY2LjMyODg4SDkuOTIxMjZDNC40NDE4MyA2LjMyODg4IDAgMTAuNzc5NCAwIDE2LjI2OTZWMTkuMTU2OEwwLjc4NDkxMiAxOC4yOTVDMy40NTM1MiAxNS4zNjU0IDcuMjI5NDYgMTMuNjk2MiAxMS4xODgyIDEzLjY5NjJIMTEuNjg4NFYxOS4xNDQ0TDIwIDEwLjAxMjVaIiBmaWxsPSIjMzU0RjVCIi8+Cjwvc3ZnPgo=";